import { InstrumentType, InstrumentDefinition, TuningDefinition } from '../types';

export const BANJO_STANDARD_TUNING: TuningDefinition = {
  id: 'banjo-standard',
  label: 'Standard Open G (Banjo)',
  pitches: [
    { note: 'G', octave: 4 },
    { note: 'D', octave: 3 },
    { note: 'G', octave: 3 },
    { note: 'B', octave: 3 },
    { note: 'D', octave: 4 },
  ],
};

export const BANJO_DEFINITION: InstrumentDefinition = {
  type: InstrumentType.Banjo,
  name: 'Banjo',
  defaultNumFrets: 22,
  defaultTunings: [BANJO_STANDARD_TUNING],
};
